import React, { useContext, useEffect, useState } from "react";
import { store } from "../../App";
import {
  NetActivity,
  DualAxesChart,
  LineChart,
  BarChart,
  MonthlyTradeVolumes,
} from "../../components";
import { FundStatement } from "./FundStatement";
import { FundPerformance } from "./FundPerformance";
import { SectorAllocation } from "./SectorAllocation";
import { ParticipantStatement } from "../../components/ParticipantStatement";
import { PerformanceBalanceHistory } from "./PerformanceBalanceHistory";
import Cookies from "js-cookie";
import { ParticipantBalances } from "./ParticipantBalances";
import { fetchDashboardTitles, FetchDataTypes } from "../../api/api";

export const Dashboard = () => {
  const [token, setToken, userId, setUserId] = useContext(store);
  const firstName: any = Cookies.get("firstName");
  const lastName: any = Cookies.get("lastName");
  const selectedClient: any = Cookies.get("client");
  const [dashBoardTitles, setDashBoardTitles] = useState<any[]>([]);

  useEffect(() => {
    fetchDashboardTitles(
      "DashboardTitles",
      parseInt(selectedClient),
      Cookies.get("newJwt")
    )
      .then((response) => response.json())
      .then((response) => {
        setDashBoardTitles(response);
      });
  }, [selectedClient]);

  const getTitleBySectionAndPart = (section: number, part: number) => {
    const titleObj = dashBoardTitles.find(
      (item) => item.dashboardSection === section && item.dashboardPart === part
    );
    return titleObj ? titleObj.dashboardTitle : "";
  };

  return (
    <div>
      <div className="header">
        <h1 className="header-title">
          Welcome back, {firstName} {lastName}!
        </h1>
      </div>
      <div className="row">
        <div className="col-12 col-md-12">
          <NetActivity title={getTitleBySectionAndPart(1, 1)} />
        </div>
        <div className="col-12 col-md-12 col-xxl-4 d-flex">
          <SectorAllocation title={getTitleBySectionAndPart(2, 1)} />
        </div>
        <div className="col-12 col-md-12 col-xxl-8 d-flex ">
          <PerformanceBalanceHistory title={getTitleBySectionAndPart(2, 2)} />
        </div>
        <div className="col-12 col-md-12 col-xxl-6 d-flex">
          <ParticipantBalances title={getTitleBySectionAndPart(3, 1)} />
        </div>
        <div className="col-12 col-md-12 col-xxl-6 d-flex">
          <ParticipantStatement title={getTitleBySectionAndPart(3, 2)} />
        </div>
        <div className="col-12 col-md-12 col-xxl-12 d-flex">
          <FundPerformance title={getTitleBySectionAndPart(4, 1)} />
        </div>
        <div className="col-12 col-md-12 col-xxl-12 d-flex">
          <FundStatement title={getTitleBySectionAndPart(5, 1)} />
        </div>
      </div>
    </div>
  );
};
